import React from 'react';
import {RouteHandler} from 'react-router';

import CurrentUserStore from '../stores/CurrentUserStore';
import AppHeader from '../components/AppHeader';


class AppTemplate extends React.Component {

    render() {
        return (
            <div className="template-app">

                <AppHeader isPro={this.props.isPro} isBsn={this.props.isBsn} user={this.props.user.profile} path={this.props.path} />

                <main className="page-content">
                    <RouteHandler {...this.props} />
                </main>
            </div>
        )
    }

    onLogout(e) {
        e.preventDefault();

        CurrentUserStore.logout();
    }
}


export default AppTemplate;



/** WEBPACK FOOTER **
 ** ./app/src/views/AppTemplate.js
 **/